export default __webpack_public_path__ + "static/media/no_user_image.da629e04.png";